import { defineMessages } from 'react-intl-next';

export const feedbackButtonMessages: {
	feedbackButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	feedbackButton: {
		id: 'search_common.feedback_button',
		defaultMessage: 'Give feedback',
		description: 'Click this button to give feedback for search.',
	},
});
